<div class="color-box" *ngIf="text" [style.background-color]="color">
  <span class="color-box_text">{{text}}</span>
</div>
